/**
 * MODULE: _shared/frontend-shell/src/design-system/components/AiAssistant/useDocRootIsDark.ts
 * PURPOSE: Subscribe to `document.documentElement` `class` (Tailwind `dark`) + system preference changes for theme-aware UI.
 */

import { useSyncExternalStore } from 'react';

function subscribe(onStoreChange: () => void) {
  const root = document.documentElement;
  const mo = new MutationObserver(() => onStoreChange());
  mo.observe(root, { attributes: true, attributeFilter: ['class'] });
  const mq = window.matchMedia('(prefers-color-scheme: dark)');
  mq.addEventListener('change', onStoreChange);
  return () => {
    mo.disconnect();
    mq.removeEventListener('change', onStoreChange);
  };
}

function getSnapshot() {
  return document.documentElement.classList.contains('dark');
}

function getServerSnapshot() {
  return false;
}

/** True when the app shell is in dark appearance (`html.dark`). */
export function useDocRootIsDark(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
